import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translate from 'react-translate-component';
import { Row, Col } from 'antd';
import { path, prop } from 'ramda';
import { withAsyncActions } from 'react-async-client';

import { APPLICATION_SIDEBAR } from 'constants/sidebarTypes';
import { applications } from 'constants/routes';
import { defaultApplicationListFilters } from 'constants/defaultFilters';
import { TabsStatusFilter } from 'components/common/controls/TabsStatusFilter';
import { getStatusPayload, setFilter } from 'helpers/filterHelpers';
import RefreshButton from 'components/common/controls/RefreshButton';
import StaticTable from 'components/common/tableComponents/StaticTable';
import { SidebarLink } from 'components/common/tableComponents/cellTemplates';
import { DateTimeField } from 'components/common/fields/DateTimeFields';

import { fullAutoOptions } from 'constants/asyncClient';
import { getApplicationList } from 'actions/asyncActions';

@withAsyncActions({
    getApplicationList: getApplicationList
        .withPayload(props => setFilter(
            prop('status', getStatusPayload(props)),
            defaultApplicationListFilters
        ))
}, fullAutoOptions)
export default class ApplicationListTable extends Component {
    static propTypes = {
        getApplicationList: PropTypes.object.isRequired,
    }

    tableColumns = [
        {
            name: 'number',
            width: 60,
            additionalClass: 'p-l-15',
            template: ({ rowIndex }) => rowIndex + 1,
        },
        {
            name: 'vacancy',
            label: <Translate content="education.application.headers.vacancy" />,
            template: ({ item }) => (
                <SidebarLink
                    componentName={APPLICATION_SIDEBAR}
                    item={item}
                    value={path(['vacancy', 'name'], item)}
                />
            ),
        },
        {
            name: 'sender',
            label: <Translate content="education.application.headers.sender" />,
            template: ({ item }) => path(['people', 'name'], item),
        },
        {
            name: 'datetime',
            width: 250,
            label: <Translate content="education.application.headers.datetime" />,
            template: ({ item }) => (
                <DateTimeField date={item.date} time={item.time} />
            ),
        }
    ];

    render() {
        const { data, meta, refresh } = this.props.getApplicationList;

        return (
            <div>
                <Row className="react-table-controls list-controls">
                    <Col span={18}>
                        <TabsStatusFilter
                            defaultFilters={defaultApplicationListFilters}
                            route={applications}
                            translate='applications'
                        />
                    </Col>
                    <Col span={6} className="text-right icon-bar">
                        <RefreshButton refreshMeta={meta} handleRefresh={refresh} />
                    </Col>
                </Row>
                <div>
                    <StaticTable
                        meta={meta}
                        refresh={refresh}
                        className="width-auto-table"
                        columns={this.tableColumns}
                        items={data.descriptions}
                    />
                </div>
            </div>
        );
    }
}
